import { apiSlice } from 'state/slices/apiSlice';

const WFHS_URL = '/wfhs';

export const wfhApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createWfh: builder.mutation({
      query: (formData) => ({
        url: `${WFHS_URL}/punch-in`,
        method: 'POST',
        body: formData,
        formData: true,
      }),
      invalidatesTags: ['WFH'],
    }),
    getWfhs: builder.query({
      query: (employeeId) => `${WFHS_URL}/list/${employeeId}`,
      providesTags: ['WFH'],
    }),
    updateWfh: builder.mutation({
      query: () => {
        return {
          url: `${WFHS_URL}/punch-out`,
          method: 'POST',
        };
      },
      invalidatesTags: ['WFH'],
    }),
    deleteWfh: builder.mutation({
      query: (id) => ({
        url: `${WFHS_URL}/delete`,
        method: 'DELETE',
        body: { id }
      }),
      invalidatesTags: ['WFH'],
    }),
    claimRecording: builder.mutation({
      query: (body) => ({
        url: `${WFHS_URL}/recordings/claim`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['WFH'],
    }),
    heartbeatRecording: builder.mutation({
      query: (body) => ({
        url: `${WFHS_URL}/recordings/heartbeat`,
        method: 'POST',
        body: { ...body, skipToast: true },
      }),
    }),
    releaseRecording: builder.mutation({
      query: (body) => ({
        url: `${WFHS_URL}/recordings/release`,
        method: 'POST',
        body: { ...body, skipToast: true },
      }),
      invalidatesTags: ['WFH'],
    }),
    uploadRecording: builder.mutation({
      query: (formData) => ({
        url: `${WFHS_URL}/recordings`,
        method: 'POST',
        body: formData,
        formData: true,
      }),
      extraOptions: { skipToastOn: [400, 409] },
      invalidatesTags: ['WFH'],
    }),
    getWfhRecordings: builder.query({
      query: ({ wfhId, skip = 0, limit }) => {
        const pageSize = limit || 6;
        return `${WFHS_URL}/${wfhId}/recordings?skip=${skip}&limit=${pageSize}`;
      },
      providesTags: ['WFH'],
    }),
  }),
});

export const {
  useCreateWfhMutation,
  useGetWfhsQuery,
  useUpdateWfhMutation,
  useDeleteWfhMutation,
  useClaimRecordingMutation,
  useHeartbeatRecordingMutation,
  useReleaseRecordingMutation,
  useUploadRecordingMutation,
  useGetWfhRecordingsQuery,
  useLazyGetWfhRecordingsQuery,
} = wfhApiSlice;
